import FormGroup from "../ui/FormGroup";
import Input from "../ui/Input";
import React from "react";
import { useClientEmail } from "../../../state/hooks/ClientHooks/useClientEmail";

const InputEmail: React.FC = () => {
    const { email, setEmail } = useClientEmail();
    return (
        <FormGroup>
            <Input
                type="email"
                name="email"
                placeholder="Email"
                value={email ? email : ""}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
            />
        </FormGroup>
    );
};

export default InputEmail;
